import { ActionIcon, Group, Text } from '@mantine/core';
import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react';

function derivePaginationNav(
  currentIndex: number,
  total: number,
  setIndex: (i: number) => void,
) {
  return {
    onPrev: currentIndex > 0 ? () => setIndex(currentIndex - 1) : undefined,
    onNext:
      currentIndex < total - 1 ? () => setIndex(currentIndex + 1) : undefined,
  };
}

export type PaginationNavProps = {
  currentIndex: number;
  total: number;
  setIndex: (i: number) => void;
};

export const PaginationNav = ({
  currentIndex,
  total,
  setIndex,
}: PaginationNavProps) => {
  const { onPrev, onNext } = derivePaginationNav(currentIndex, total, setIndex);

  return (
    <Group gap={4}>
      <Text size="sm" c="dimmed">
        {currentIndex + 1} / {total}
      </Text>
      <ActionIcon
        variant="subtle"
        color="gray"
        size="sm"
        onClick={onPrev}
        disabled={!onPrev}
      >
        <IconChevronLeft size={14} />
      </ActionIcon>
      <ActionIcon
        variant="subtle"
        color="gray"
        size="sm"
        onClick={onNext}
        disabled={!onNext}
      >
        <IconChevronRight size={14} />
      </ActionIcon>
    </Group>
  );
};
